import ApiService, { callCustomMethodAsync } from '../service/ApiService'

let moduleApi = {}
let moduleName = 'notification'

moduleApi.update = async (dataForm,loading) => {
  let api = {
    module: moduleName,
    type: 'partialUpdate',
    value: dataForm,
    dontLoading: (loading == undefined ? false : loading ),
    message: {
      success: 'hidden',
      error: 'hidden'
    }
  }

  const result = await ApiService(api)
  mushroom[moduleName].invalidCache()
  return result
}

moduleApi.list = async (dataFilter,loading) => {
  let api = {
    module: moduleName,
    type: 'list',
    value: dataFilter,
    dontLoading: (loading == undefined ? false : loading ),
  }

  const result = await ApiService(api)
  mushroom[moduleName].invalidCache()
  return result
}

moduleApi.delete = async (id) => {
  let api = {
    module: moduleName,
    type: 'delete',
    value: {id: id}
  }

  const result = await ApiService(api)
  mushroom[moduleName].invalidCache()
  return result
}

moduleApi.findById = async (id) => {
  let api = {
    module: moduleName,
    type: 'findById',
    value: {id: id},
    message: {
      success: 'hidden',
      error: 'hidden'
    }
  }

  const result = await ApiService(api)
  mushroom[moduleName].invalidCache()
  return result
}

moduleApi.markAllAsRead = async (dataBody, loading) => {
  let api = {
    module: moduleName,
    body: dataBody,
    type: 'mark_all_as_read',
    dontLoading: (loading == undefined ? false : loading ),
    message: {
      success: 'hidden',
      error: 'hidden'
    }
  }

  const result = await callCustomMethodAsync(api)
  mushroom[moduleName].invalidCache()
  return result
}

export default moduleApi
